app.controller("ApartmentSearchController",
	["$scope", "$rootScope", "$filter", "$timeout", "$http", "$location", "ApartmentSearchModel", "ApartmentSearchService", "BrowserStorageService", function($scope, $rootScope, $filter, $timeout, $http, $location, ApartmentSearchModel, ApartmentSearchService, BrowserStorageService) {
		$scope.SearchModel = ApartmentSearchModel;
		$scope.displayMaxPrice = ApartmentSearchModel.priceRange.max;
		$scope.showStickyFull = false;
		$scope.showExpanded = false;
		$scope.searchExpanded = false;
		$scope.redirectSearch = false;
		$scope.historyOpen = false;
		$scope.searchHistory = ApartmentSearchService.searchHistory;
		// Old IE's return empty, so do not hide then :(
		$scope.hidden = ($location.path().toString() === '/haku' || $location.path().toString() === '/' || $location.path().toString() === "") ? false : true;
		$scope.addressSearch = {
			suggestions: [
				{
					type: "region",
					name: "Lääni",
					values: []
				},
				{
					type: "county",
					name: "Maakunta",
					values: []
				},
				{
					type: "municipality",
					name: "Kunta",
					values: []
				},
				{
					type: "city",
					name: "Kaupunki",
					values: []
				},
				{
					type: "district",
					name: "Kaupunginosa/alue",
					values: []
				},
				{
					type: "address",
					name: "Osoite",
					values: []
				},
				{
					type: "postcode",
					name: "Postinumero",
					values: []
				}
			],
			input: "",
			active: 0
		};
		$scope.showAreaDropdown = false;
		$scope.apartmentID = undefined;
		$scope.showMonthlyModal = false;
		// Huom: hakusivulla tämä asetetaan twigin kautta, muuten oletuksena aina tyhjä.
		$scope.searchParams = null;
		$scope.searchID = "mainSearch";

		$rootScope.$on('searchHistoryChanged', function(oldValue, newValue) {
			$scope.searchHistory = ApartmentSearchService.searchHistory;
		});

		var addressTypes = {
			county: "maakunta",
			district: "kaupunginosa",
			municipality: "kunta",
			city: "kaupunki",
			address: "osoite",
			postcode: "postinumero",
			region: "lääni"
		};

		$scope.InitQuery = function() {
			if(typeof($scope.searchParams) == 'object' && $scope.searchParams != null && !Array.isArray($scope.searchParams)) {
				BuildNewQueryFromSearchParams();
			}
			else {
				var queryBlob = BrowserStorageService.LocalStorage.GetItem("ApartmentSearchQuery");
				if(queryBlob != null && queryBlob.queryVersion == ApartmentSearchModel.query.GetQueryVersion()) {
					ApartmentSearchModel.query.MergeStorageQueryBlob(queryBlob);
					//$scope.RemoveUsedConstraints();
				}
				else {
					BrowserStorageService.LocalStorage.SetItem("ApartmentSearchQuery", ApartmentSearchModel.query.GetAsStorageBlob());
				}
			}

			// Tell the service which is it?
			ApartmentSearchService.redirectSearch = $scope.redirectSearch;

			// Vasta seuraavassa digest-cyclessä, jotta notificationListenerit ehtii rekisteröityä turvallisesti hierarkiasta riippumatta.
			$timeout(function() {
				ApartmentSearchService.SendNotification("ApartmentSearchBarReady", { searchID: $scope.searchID, query: ApartmentSearchModel.query });
			});

		};

		$scope.ToHeadStart = function(href) {
			BrowserStorageService.LocalStorage.SetItem("ApartmentSearchQuery", ApartmentSearchModel.query.GetAsStorageBlob());
			if(typeof(href) != 'undefined') {
				window.location.href = href;
			}
		};

		// Very, very dirty.
		function BuildNewQueryFromSearchParams() {
			ApartmentSearchModel.query = ApartmentSearchService.CreateQuery();
			for(var p in $scope.searchParams) {
				if($scope.searchParams.hasOwnProperty(p)) {
					switch(p) {
						case 'groupType':
							var housetype = ApartmentSearchModel.query.GetStandardConstraints().groupType;
							for(var i = 0; i < housetype.length; i++) {
								if(housetype[i].mapping == $scope.searchParams[p]) {
									ApartmentSearchModel.query.GetHouseTypeConstraints()[i].selected = true;
									break;
								}
							}
							if($scope.searchParams[p] == 'uudiskohteet') {
								ApartmentSearchModel.query.SetNewConstructionConstraints(1);
								break;
							}
							break;
						case 'rental':
							ApartmentSearchModel.query.SetRental($scope.searchParams[p]);
							break;
						case 'city':
							var addr = {
								type: 'city',
								value: $scope.searchParams.city,
								query: {
									city: $scope.searchParams.city
								},
								parsedValue: $scope.searchParams.city + ', ' + addressTypes['city']
							};
							if($scope.searchParams.district) {
								addr.type = 'district';
								addr.value = $scope.searchParams.district + ', ' + $scope.searchParams.city;
								addr.query = {
									district: $scope.searchParams.district,
									city: $scope.searchParams.city
								};
								addr.parsedValue = $scope.searchParams.district + ', ' + addressTypes['district'];
							}
							ApartmentSearchModel.query.AddAddressConstraint(addr);
							break;
						case 'video':
							if ($scope.searchParams[p]) {
								ApartmentSearchModel.query.SetVideo(true);
							}
							break;
					}
				}

			}

		}

		function GetAddressSuggestionsCount() {
			var count = 0;
			for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
				count += $scope.addressSearch.suggestions[i].values.length;
			}
			return count;
		}

		function GetAddressByAssignedIndex(index) {
			for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
				var addressType = $scope.addressSearch.suggestions[i].type;
				var subAddrArray = $scope.addressSearch.suggestions[i].values;
				for(var j = 0; j < subAddrArray.length; j++) {
					if(subAddrArray[j].index == index) {
						return subAddrArray[j];
					}
				}
			}
			return undefined;
		}

		function ParseAddressSuggestions(suggestions) {

			for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
				var addressType = $scope.addressSearch.suggestions[i].type;
				var addressTypeName = $scope.addressSearch.suggestions[i].name;
				$scope.addressSearch.suggestions[i].values.length = 0;
				for(var j = 0; j < suggestions.length; j++) {
					if(suggestions[j].type == addressType) {
						suggestions[j].index = j;
						suggestions[j].parsedValue = suggestions[j].value + ", " + addressTypeName;
						$scope.addressSearch.suggestions[i].values.push(suggestions[j]);
					}
				}
			}

			// Resetoidaan aktiivinen arvo aina kun on haettu uusi setti osoite-ehdotuksia.
			if(suggestions.length > 0) {
				$scope.addressSearch.active = 0;
			}
			else {
				$scope.addressSearch.active = -1;
			}
		}


		$scope.$watch('addressSearch.input', function(newVal) {
			if(newVal !== "") {
				$scope.GetAddressSuggestions(newVal);
			}
		});


		$scope.HandleAreaDropdownKeyPress = function(event) {

			// Up
			if(event.which == 38) {
				$scope.addressSearch.active = $scope.addressSearch.active > 0 ? $scope.addressSearch.active - 1 : GetAddressSuggestionsCount() - 1;
			}
			// Down
			else if(event.which == 40) {
				$scope.addressSearch.active = $scope.addressSearch.active < GetAddressSuggestionsCount() - 1 ? $scope.addressSearch.active + 1 : 0;
			}
			// Enter
			else if(event.which == 13) {
				if($scope.addressSearch.input.length > 0) {
					$scope.AddSearchAddress(GetAddressByAssignedIndex($scope.addressSearch.active), event);
				}
			}
			// ESC
			else if(event.which == 27) {

			}
			else {
				$scope.addressSearch.active = 0;
			}
		};

		$scope.HandleApartmentIdEnter = function(event) {
			if(event.which == 13) {
				$scope.RunSearchWithID();
			}
		};

		$scope.DisplayedMaxPrice = function() {
			var q = ApartmentSearchModel.query;
			if(q.GetPriceConstraints().min == ApartmentSearchModel.priceRange.ceil || q.GetPriceConstraints().max == ApartmentSearchModel.priceRange.ceil) {
				var price = $filter('currency')(ApartmentSearchModel.priceRange.actualceil, ' ', ' ', ' ', 0);
				return (price + '+');
			}
			else {
				return $filter('currency')(q.GetPriceConstraints().max, ' ', ' ', ' ', 0);
			}
		};

		$scope.DisplayedMaxRentalPrice = function() {
			var q = ApartmentSearchModel.query;
			if(q.GetRentalPriceConstraints().min == ApartmentSearchModel.rentalPriceRange.ceil || q.GetRentalPriceConstraints().max == ApartmentSearchModel.rentalPriceRange.ceil) {
				var price = $filter('currency')(ApartmentSearchModel.rentalPriceRange.actualceil, ' ', ' ', ' ', 0);
				return (price + '+');
			}
			else {
				return $filter('currency')(q.GetRentalPriceConstraints().max, ' ', ' ', ' ', 0);
			}
		};

		$scope.DisplayStickySearch = function() {
			//console.log("display sticky search");
			$scope.showSticky = true;
			$scope.showAreaDropdown = false;
		};

		$scope.HideStickySearch = function() {
			//console.log("hide sticky search");
			$scope.showSticky = false;
			$scope.showStickyFull = false;
			$rootScope.$broadcast('customized-dropdown/searchAreaDropdown/close');
			$rootScope.$broadcast('customized-dropdown/searchAreaSuggestionsDropdown/close');
		};

		// Tuo sticky search slider kokonaan näkyviin.
		$scope.ToggleStickySearchVisible = function() {
			$scope.showStickyFull = !$scope.showStickyFull;
		};

		$scope.SwitchSearchConstraint = function(index, constraint) {
			$scope.SearchModel.unusedConstraints.push($scope.SearchModel.query.GetExtendedConstraints()[index]);
			$scope.SearchModel.query.GetExtendedConstraints()[index] = constraint;
			for(var i = 0; i < $scope.SearchModel.unusedConstraints.length; i++) {
				if($scope.SearchModel.unusedConstraints[i].internalId == constraint.internalId) {
					$scope.SearchModel.unusedConstraints.splice(i, 1);
					return;
				}
			}
		};

		$scope.ClearConstraints = function() {
			$scope.SearchModel.query.ResetToDefaultConstraints();
			BrowserStorageService.LocalStorage.RemoveItem('monthlyPayment');
			//$scope.SearchModel.unusedConstraints = ApartmentSearchService.GetAvailableConstraintList();
		};

		$scope.RunSearchWithID = function() {

			if($scope.apartmentID !== undefined && $scope.apartmentID.length > 0) {
				window.location.pathname = '/kohde/' + $scope.apartmentID;
			}
			console.log("Apartment id search: ", $scope.apartmentID);

		};

		$scope.RunSearch = function(isRedirect) {
			_gaq.push(['_trackEvent', 'Kohdehaku', 'Lähetä']);
			if(!isRedirect) {
				ApartmentSearchModel.query.SetSkip(0);
				BrowserStorageService.LocalStorage.SetItem("ApartmentSearchQuery", ApartmentSearchModel.query.GetAsStorageBlob());
				ApartmentSearchService.RunQuery(ApartmentSearchModel.query, $scope.searchID, false, function() {
					$("body").animate({ scrollTop: 0 }, "slow");
				});
			}
			else {
				var queryBlob = ApartmentSearchModel.query.GetAsStorageBlob();
				BrowserStorageService.LocalStorage.SetItem("ApartmentSearchQuery", queryBlob);
			}
		};

		$scope.GetAddressSuggestions = function(text) {

			$http({
				method: 'GET',
				url: '/api/km/KM/search',
				params: {
					key: text,
					limit: 50
				}
			}).then(function(results, status, headers, config) {
				ParseAddressSuggestions(results.data.data.results);
				// todo: kun 0, antamallasi hakusanalla ei löytynyt kohteita
			}, function(data, status, headers, config) {
				console.log("error getting address suggestions:", data);
			});
		};

		$scope.GetSearchAreaText = function() {
			var addressString = "Valitse alue";
			if($scope.SearchModel.query.GetAddressConstraints().length > 0) {
				addressString = "";

				for(var i = 0; i < $scope.SearchModel.query.GetAddressConstraints().length; i++) {
					addressString += $scope.SearchModel.query.GetAddressConstraints()[i].value;
					if(i != $scope.SearchModel.query.GetAddressConstraints().length - 1) {
						addressString += ", ";
					}
				}

				addressString = addressString.length > 15 ? addressString.substr(0, 14) + "…" : addressString;
			}

			return addressString;
		};

		$scope.GetHouseTypeText = function() {
			var houseTypeString = 'Valitse asuntotyyppi';
			var selectedTypes = [];

			for (var i = 0, max = $scope.SearchModel.query.GetHouseTypeConstraints().length; i < max; i++) {
				if ($scope.SearchModel.query.GetHouseTypeConstraints()[i].selected === true) {
					selectedTypes.push($scope.SearchModel.query.GetHouseTypeConstraints()[i].name);
				}
			}

			if (selectedTypes.length) {
				houseTypeString = selectedTypes.join(', ');
			}

			houseTypeString = (houseTypeString.length > 15 && selectedTypes.length) ? houseTypeString.substr(0, 14) + '…' : houseTypeString;

			return houseTypeString;
		};

		$scope.AddSearchAddress = function(address, event) {
			if(typeof(address) == 'undefined') {
				return false;
			}
			event.preventDefault();
			event.stopPropagation();
			ApartmentSearchModel.query.AddAddressConstraint(address);
			$scope.addressSearch.input = "";
			for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
				$scope.addressSearch.suggestions[i].values.length = 0;
			}
			$scope.addressSearch.active = -1;
		};

		$scope.RemoveSearchAddress = function(index, event) {
			event.preventDefault();
			event.stopPropagation();
			ApartmentSearchModel.query.RemoveAddressConstraint(index);
		};

		$scope.OpenHistoryView = function() {
			$scope.historyOpen = !$scope.historyOpen;
		};

		$scope.GotoSearchResult = function(item) {
			$scope.HideHistory();

			BrowserStorageService.LocalStorage.SetItem('ApartmentSearchQuery', item);
			ApartmentSearchService.SaveSearchHistory(item);
			ApartmentSearchModel.query.MergeStorageQueryBlob(item);
		};

		$scope.HideHistory = function() {
			$scope.historyOpen = false;
		};

		$scope.toggleMonthlyModal = function() {
			console.log($scope.SearchModel.query.GetPriceConstraints());
			$scope.showMonthlyModal = !$scope.showMonthlyModal;
		};

		/**
		 * This is not really init, this is a callback.
		 *
		 * @param isRedirect
		 */
		$scope.initMonthlySearch = function(isRedirect) {
			// Seems to be just causing double loads, let the watches to notice the price change
			//ApartmentSearchService.SendNotification("ApartmentSearchBarReady", { searchID: $scope.searchID, query: ApartmentSearchModel.query });

			$timeout(function() {
				if (isRedirect) {
					window.location.href = '/haku';
					BrowserStorageService.LocalStorage.SetItem("ApartmentSearchQuery", ApartmentSearchModel.query.GetAsStorageBlob());
				}
			}, 750);
		};

		$scope.GetSelectedGroupType = function() {
			var selected = [];

			for (var i = 0, max = ApartmentSearchModel.query.GetStandardConstraints().groupType.length; i < max; i++) {
				if (ApartmentSearchModel.query.GetStandardConstraints().groupType[i].selected === true) {
					if (ApartmentSearchModel.query.GetStandardConstraints().groupType[i].mapping === 'maatilat-metsatilat') {
						selected.push('maatilat ja metsätilat');
					}
					else if (ApartmentSearchModel.query.GetStandardConstraints().groupType[i].mapping === 'rivitalot-paritalot') {
						selected.push('rivitalot ja paritalot');
					}
					else if (ApartmentSearchModel.query.GetStandardConstraints().groupType[i].mapping === 'vapaa-ajan_asunnot') {
						selected.push('mökit ja vapaa-ajan asunnot');
					}
					else {
						selected.push(ApartmentSearchModel.query.GetStandardConstraints().groupType[i].mapping);
					}
				}
			}

			return selected;
		};
	}]
);